export const FreePassErrorReasons = {
  PromoNotActive: 'promo_not_active',
  PromoExpired: 'promo_expired',
  AlreadyParticipated: 'already_participated',
  PromoAlreadyCompleted: 'promo_already_completed',
  PromoNoItems: 'promo_no_items',
  UserNotParticipated: 'user_not_participated',
  NoActiveItem: 'no_active_item',
  ItemAlreadyClaimed: 'item_already_claimed',
  Unknown: 'unknown',
} as const;

export type FreePassErrorReason =
  typeof FreePassErrorReasons[keyof typeof FreePassErrorReasons];

export class FreePassError extends Error {
  reason: FreePassErrorReason;

  constructor(reason: FreePassErrorReason) {
    super(`free-pass: ${reason}`);
    this.name = 'FreePassError';
    this.reason = reason;
  }
}
